export const getQueryString = () => new URL(window.location.href).search;
